<template>
  <nav v-if="userUUID" class="navbar" :class="classes">
    <a class="sidebar-toggler" @click.prevent="toggle">
      <font-awesome-icon icon="bars" size="lg" id="messageDropdown" role="button" data-bs-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false" />
    </a>
    <div class="navbar-content">

      <ul class="navbar-nav">


        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle " href="#" id="profileDropdown" role="button" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <img class="wd-30 ht-30 rounded-circle" src="@/assets/img/icons/member.png" alt="profile" />
            <img class="wd-30 ht-30 rounded-circle" src="@/assets/img/cachet-signe.png" alt="profile" />
          </a>
          <div class="dropdown-menu  " aria-labelledby="profileDropdown">
            <div class="d-flex flex-column align-items-center bcustom-alert-bottom px-5 py-1 border-bottom">
              <div class="text-left">
                <p class="tx-16 text-uppercase ">
                  <b>{{ user?.firstName || '' }} {{ user?.lastName || '' }} </b>
                </p>
              </div>
              <div class="text-left">
                <p class="tx-16 "> {{ user?.email || '' }} </p>
              </div>
            </div>


            <ul class="list-unstyled ">


              <li class="dropdown-item py-2 cursor-pointer border-bottom">
                <router-link :to="{ name: 'profile', params: { userUUID: userUUID } }"
                  class="bg-none text-body ms-0 d-block w-100">
                  <font-awesome-icon icon="user-tie" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.profile') }} </span>
                </router-link>
              </li>

              <li class="dropdown-item py-2 cursor-pointer" @click.prevent="logout">
                <a class="text-body ms-0">
                  <font-awesome-icon icon="sign-out-alt" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.logout') }} </span>
                </a>
              </li>


            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts">
import Swal from "sweetalert2";
import { useI18n } from 'vue3-i18n';
import i18n from "@/i18n/index"
import { defineComponent, ref, computed, toRefs } from 'vue';
import { selectedLang, userUUID, clubUUID, currentClub, user } from '@/shared/state';
import { useGlobal } from "@/composables/global/useGlobal";
import { useLogin } from '@/composables/auth/useLogin';
import { useClub } from '@/composables/club/useClub';
import { useUser } from "@/composables/auth/useUser";


export default defineComponent({
  props: {
    classes: {
      type: Object,
      default: null,
    }
  },

  name: 'NavBar',
  setup(props) {
    const { classes } = toRefs(props);
    const { formaDate } = useGlobal();



    const { logout, error } = useLogin();
    const { hasAdminRole } = useUser();


    const changeLanguage = (lang: string) => {
      localStorage.setItem('selectedLang', lang)
      i18n.setLocale(lang)
      selectedLang.value = lang
      if (lang == "ar") {
        localStorage.setItem('style', 'rtl')
      } else {
        localStorage.setItem('style', 'ltr')
      }
    };

    return {

      logout,
      currentClub,
      userUUID,
      clubUUID,
      error,
      changeLanguage,
      i18n,
      user,
      selectedLang,
      formaDate,
      hasAdminRole
    };
  },
});
</script>